export default __webpack_public_path__ + "static/media/spin.709be992.svg";